import { push } from "connected-react-router";
import { Field, Form, Formik } from "formik";
import { isEmpty } from "lodash";
import Button from "pages/_components/Button";
import TextField from "pages/_components/fields/TextField";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { actions as contactActions } from "reducers/contactDestination";
import * as i18n from "util/i18n";
import * as Yup from "yup";
import ContactSummaryBody from "./_components/ContactSummary";

const FORM_ID = "frequentDestination.create";

const ModifyContactPage = () => {
    const dispatch = useDispatch();
    const { id } = useParams();
    const { frequentDestinationModify, fetching } = useSelector((state) => state.contactDestination);

    useEffect(() => {
        if (isEmpty(frequentDestinationModify)) {
            dispatch(contactActions.modifyFrequentDestinationPreRequest(id));
        }
    }, []);

    const initialValues = {
        email: frequentDestinationModify.recipientEmail || "",
        name: frequentDestinationModify.name || "",
    };

    const handleSubmit = (values) => {
        const { email, name } = values;
        const submitValues = {
            recipientEmail: email,
            name,
        };
        dispatch(
            contactActions.modifyFrequentDestinationPreviewRequest({
                ...submitValues,
                idFrequentDestination: frequentDestinationModify.idFrequentDestination,
            }),
        );
        dispatch(push(`/contactDestination/${frequentDestinationModify.idFrequentDestination}/modify/confirmation`));
    };

    const newContactSchema = Yup.object().shape({
        email: Yup.string().email(i18n.get(`global.incorrect.format`)),
        name: Yup.string().required(i18n.get(`global.error.required`)),
    });

    return (
        <>
            <Notification scopeToShow="FrequentDestinationsModify" />
            <ResponsiveHeader id="frequentDestination.modify.tittle" />
            <MainContainer showLoader={fetching}>
                <ContactSummaryBody
                    accountNumber={frequentDestinationModify.accountNumber}
                    productType={frequentDestinationModify?.productType}
                    cbu={frequentDestinationModify.cbu}
                    name={frequentDestinationModify.name}
                    localBank={frequentDestinationModify.localBank}
                    recipientEmail={frequentDestinationModify.recipientEmail}
                    recipientDocumentType={frequentDestinationModify.recipientDocumentType}
                    recipientDocumentNumber={frequentDestinationModify.recipientDocumentNumber}
                    recipientName={frequentDestinationModify.recipientName}
                    isOwn={frequentDestinationModify.isOwn}
                    isModify
                />
                {!isEmpty(frequentDestinationModify) && (
                    <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={newContactSchema}>
                        {({ values, isSubmitting }) => {
                            const hasSameValues =
                                values.email === frequentDestinationModify.recipientEmail &&
                                values.name === frequentDestinationModify.name;
                            const canSubmit = !values.email || !values.name || hasSameValues;

                            return (
                                <Form>
                                    <Row>
                                        <Col xs={12} md={4} mdOffset={2}>
                                            <Field
                                                component={TextField}
                                                idForm={FORM_ID}
                                                name="email"
                                                type="email"
                                                hidePlaceholder
                                            />
                                        </Col>

                                        <Col xs={12} md={4}>
                                            <Field
                                                component={TextField}
                                                idForm={FORM_ID}
                                                name="name"
                                                type="text"
                                                hidePlaceholder
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="form-actions">
                                        <Col xs={12} md={4} mdOffset={4}>
                                            <Button
                                                type="submit"
                                                loading={isSubmitting}
                                                className="btn-primary"
                                                label="global.continue"
                                                disabled={canSubmit}
                                                block
                                            />
                                        </Col>
                                    </Row>
                                </Form>
                            );
                        }}
                    </Formik>
                )}
            </MainContainer>
        </>
    );
};

export default ModifyContactPage;
